import useCarouselLayout from "../../hooks/useCarouselLayout";
import "./PlacementWall.css";

import {
  FaBuilding,
  FaMapMarkerAlt,
  FaRupeeSign,
  FaLinkedin,
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";

import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


const placements = [
  {
    id: 1,
    name: "Rahul Sharma",
    company: "TCS",
    position: "Software Engineer",
    package: "7.2 LPA",
    location: "Kolkata",
    year: "2026",
    image: "https://i.pravatar.cc/150?img=11",
  },
  {
    id: 2,
    name: "Priya Das",
    company: "Infosys",
    position: "Systems Engineer",
    package: "6.5 LPA",
    location: "Bangalore",
    year: "2026",
    image: "https://i.pravatar.cc/150?img=21",
  },
  {
    id: 3,
    name: "Amit Roy",
    company: "Capgemini",
    position: "Full Stack Developer",
    package: "8.1 LPA",
    location: "Hyderabad",
    year: "2026",
    image: "https://i.pravatar.cc/150?img=15",
  },
  {
    id: 4,
    name: "Sneha Paul",
    company: "Wipro",
    position: "Backend Developer",
    package: "7.8 LPA",
    location: "Pune",
    year: "2026",
    image: "https://i.pravatar.cc/150?img=25",
  },
    {
    id: 5,
    name: "Sneha Paul",
    company: "Wipro",
    position: "Backend Developer",
    package: "7.8 LPA",
    location: "Pune",
    year: "2026",
    image: "https://i.pravatar.cc/150?img=25",
  },
    {
    id: 5,
    name: "Sneha Paul",
    company: "Wipro",
    position: "Backend Developer",
    package: "7.8 LPA",
    location: "Pune",
    year: "2026",
    image: "https://i.pravatar.cc/150?img=25",
  },
];


function PlacementArrow({ className, style, onClick, direction }) {
  return <button type="button" className={`${className} placement-slider-arrow`} style={style} onClick={onClick} aria-label={`${direction === "previous" ? "Previous" : "Next"} placements`}>
    {direction === "previous" ? <FaChevronLeft aria-hidden="true" /> : <FaChevronRight aria-hidden="true" />}
  </button>;
}

function PlacementWall() {
  const { containerRef, slidesToShow } = useCarouselLayout(3, 1100);


  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    autoplay: true,
    autoplaySpeed: 3500,
    pauseOnHover: true,
    pauseOnFocus: true,
    slidesToShow,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: <PlacementArrow direction="previous" />,
    nextArrow: <PlacementArrow direction="next" />,


  };


  return (

    <section className="placement-wall" ref={containerRef}>


      <div className="placement-wall-title">
        <span className="placement-wall-eyebrow">THE NEXT CHAPTER</span>

        <h2>
          Placement Success Wall
        </h2>

        <p>
          Our students are working in leading companies around the world.
        </p>

      </div>



      <Slider {...settings} className="placement-slider">


        {placements.map((student, index)=>(


          <div className="placement-slide" key={`${student.id}-${index}`}>


            <div className="placement-wall-card">


              <div className="placement-wall-image">

                <img 
                  src={student.image}
                  alt={student.name}
                  loading="lazy"
                />

                <span>
                  {student.year}
                </span>

              </div>



              <div className="placement-wall-body">


                <h3>
                  {student.name}
                </h3>


                <h4>
                  {student.position}
                </h4>



                <div className="placement-wall-info">


                  <p>
                    <FaBuilding/>
                    {student.company}
                  </p>


                  <p>
                    <FaMapMarkerAlt/>
                    {student.location}
                  </p>


                  <p>
                    <FaRupeeSign/>
                    {student.package}
                  </p>


                </div>



                <button>

                  <FaLinkedin/>
                  View Success Story

                </button>


              </div>


            </div>


          </div>


        ))}


      </Slider>


    </section>

  );
}


export default PlacementWall;
